<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppBasePlaceholder } from '@libs/ui';

import type { ItineraryUpsellLoaderSegment } from '../../../models';
import ItineraryTimeline from '../ItineraryTimeline.vue';

const { t } = i18n.global;

const browserStore = useBrowserStore();

interface ItineraryUpsellingLoaderProps {
  segment: ItineraryUpsellLoaderSegment;
}
const props = defineProps<ItineraryUpsellingLoaderProps>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="itinerary-upselling-loader"
  >
    <template #banner>
      <AppBasePlaceholder
        class="upsell-placeholder"
        :title="
          t('overview_placeholder.activity.title', [props.segment.destination])
        "
        :description="t('overview_placeholder.activity.description')"
        :is-small-device="browserStore.isSmallerThan900px"
        :icon-properties="{
          name: 'activityOutlined',
          color: 'color-brand-coral',
        }"
        :actions="[
          {
            textToDisplay: t('placeholder.add_activity'),
            eventType: '',
          },
        ]"
        is-loading
      />
    </template>
  </ItineraryTimeline>
</template>

<style lang="scss" scoped>
.upsell-placeholder {
  @include for-less-or-equal-than-1199-px {
    margin-left: var(--spacing-8);
  }
  @include for-less-or-equal-than-599-px {
    margin-left: 0;
  }
}
</style>
